<template>
	<default-popup extra-class="user-activation-popup no-transparent" :disable-close="true">
		<div class="content" v-if="showActivationForm">
			<h2 class="popup-title">{{ $t('auth.please_activate_account') }}</h2>
			<p>{{ $t('auth.enter_sms_code') }} {{ phone }}</p>
			<user-activation-form @change-phone="showActivationForm = false"/>
		</div>
		<div class="contnet" v-else>
			<h2 class="popup-title">{{ $t('auth.please_activate_account') }}</h2>
			<user-change-phone-form @show-activation-form="showActivationForm = true" @phone-changed="handlePhoneChanged"/>
		</div>
	</default-popup>
</template>

<script>
	import DefaultPopup from "./DefaultPopup";
	import UserActivationForm from "../forms/UserActivationForm";
	import UserChangePhoneForm from "../forms/UserChangePhoneForm.vue";

	export default {
		name: "UserActivationPopup",
		components: {
			DefaultPopup,
			UserActivationForm,
			UserChangePhoneForm
		},
		data() {
			return {
				showActivationForm: true,
				phone: this.$store.state.auth.user.phone,
			}
		},
		methods: {
			handlePhoneChanged(data){
				this.phone = data;
				this.showActivationForm = true;
			}
		}
	}
</script>

<style scoped lang="scss">
	.popup-inner {
		.user-activation-form {
			margin-top: 50px;
		}
		.user-change-phone-form {
			margin-top: 50px;
		}
	}
</style>